import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useAuthState } from '../../../../Helper/Context/context';
import { CommanOtherPostAPI } from '../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartThirdSlice';


export default function OtherInsertSection(props) {
    const { PlantdistancesId, Flag, handleIsPost, IsOthersData, setIsOthersData } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [OtherTextField, setOtherTextField] = useState('')

    const handleIsOtherPost = () => {
        setIsOthersData(!IsOthersData)
        setOtherTextField('')
    }

    const handleSaveData = () => {
        const data = {
            Other: OtherTextField,
            Flag: Flag,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsOtherPost: handleIsOtherPost
        }
        dispatch(CommanOtherPostAPI({ data }))
    }

    const { isLoading } = useSelector(state => state.CommanOtherPostData)

    return (
        <>
            <div className='row '>
                <div className="col-12 col-lg-6">
                    <div class="input-group mb-3 mt-lg-2">
                        <input type="text"
                            className="form-control"
                            name="OtherTextField"
                            placeholder="type here"
                            value={OtherTextField}
                            onChange={(e) => setOtherTextField(e.target.value)}
                        />
                        <span className="input-group-text cursor-pointer" id="basic-addon2" onClick={handleSaveData}>
                            Save</span>
                    </div>
                </div>
            </div>



        </>
    )
}
